export default "__VITE_ASSET__vOQSRarx__"